import { read_u16, read_u32, Sink } from "../../helpers/serializerHelpers";

export class TemperatureData {
    public timeStamp: number = 0;

    /* Antenna Temperature Readings */
    public rx0: number = 0;
    public rx1: number = 0;
    public rx2: number = 0;
    public rx3: number = 0;

    public tx0: number = 0;
    public tx1: number = 0;
    public tx2: number = 0;

    /* PM Reading */
    public pm: number = 0;

    /* Digital Sensor Readings */
    public digital0: number = 0;
    public digital1: number = 0;

    public deserialize(bytes: Sink) {
        this.timeStamp = read_u32(bytes);

        this.rx0 = read_u16(bytes);
        this.rx1 = read_u16(bytes);
        this.rx2 = read_u16(bytes);
        this.rx3 = read_u16(bytes);

        this.tx0 = read_u16(bytes);
        this.tx1 = read_u16(bytes);
        this.tx2 = read_u16(bytes);

        /* PM Reading */
        this.pm = read_u16(bytes);

        /* Digital Sensor Readings */
        this.digital0 = read_u16(bytes);
        this.digital1 = read_u16(bytes);

        return this;
    }
}
